import service from '@/http/HttpInterceptor.js'
import API_LIST from '@/api/config'
// import store from '@/store'
// import AMap from 'AMap'
/**
 * 获取当前位置--经纬度--城市名称
 *
 */
// export const getMapData = (callback) => {
//   if (store.state.app.cityName !== null) {
//     callback()
//     return
//   }
//   const map = new AMap.CitySearch()
//   map.getLocalCity((status, result) => {
//     if (status === 'complete' && result.info === 'OK') {
//       if (result && result.city && result.bounds) {
//         store.commit('SET_MAPDATA', result)
//         callback(result)
//       }
//     }
//   })
// }
/**
 * 录入访客信息
 * @params {*} isApp
 * @params {*} visitTitle
 * @params {*} visitorCity
 * @params {*} visitorLatitude
 * @params {*} visitorLongitude
 */
export const insertVistor = (params) => {
  return service({
    url: API_LIST.visit.insert,
    method: 'post',
    data: params
  })
}
export const VistorRead = (params) => {
  return service({
    url: API_LIST.visit.read,
    method: 'post',
    data: params
  })
}
/**
 * 获取分享参数
 * @params {*} url--当前页面完整的url
 */
export const getShareParams = (params) => {
  return service({
    url: API_LIST.common.share,
    method: 'get',
    params: params
  })
}
export const getSysTime = (params) => {
  return service({
    url: API_LIST.user.sysTime,
    method: 'get',
    params: params
  })
}

export const getAllData = (params) => {
  return service({
    url: API_LIST.act.allData,
    method: 'get',
    params: params
  })
}

export const getList = (params) => {
  return service({
    url: API_LIST.act.list,
    method: 'get',
    params: params
  })
}

// 获取歌曲列表
export const getSongList = (params) => {
  return service({
    url: API_LIST.act.songlist,
    method: 'post',
    data: params
  })
}
// 获取歌曲详情
export const getSongdetail = (params) => {
  return service({
    url: API_LIST.act.songdetail,
    method: 'get',
    params: params
  })
}
export const getDetail = (params) => {
  return service({
    url: API_LIST.act.actDetail,
    method: 'get',
    params: params
  })
}
// 歌词歌曲投稿
export const getSong = (params) => {
  return service({
    url: API_LIST.act.song,
    method: 'post',
    data: params
  })
}
// 获取统计数据
export const getTotalNum = (params) => {
  return service({
    url: API_LIST.act.totalNum,
    method: 'get',
    params: params
  })
}
// 专家列表
export const getSpecialList = (params) => {
  return service({
    url: API_LIST.act.special,
    method: 'get',
    params: params
  })
}
// 专家详情 userCode
export const getSpecialDetail = (params) => {
  return service({
    url: API_LIST.act.specialDetail,
    method: 'get',
    params: params
  })
}
// 文件上传
export const uploadWorks = (params) => {
  return service({
    url: API_LIST.act.upload,
    method: 'post',
    data: params
  })
}
// 后台获取列表
export const getBackList = (params) => {
  return service({
    url: API_LIST.backEnd.list,
    method: 'get',
    params: params
  })
}
// 后台详情
export const getBackDetail = (params) => {
  return service({
    url: API_LIST.backEnd.detail,
    method: 'get',
    params: params
  })
}
// 后台编辑
export const backUpdate = (params) => {
  return service({
    url: API_LIST.backEnd.update,
    method: 'post',
    data: params
  })
}
// 后台删除
export const backDelete = (params) => {
  return service({
    url: API_LIST.backEnd.delete,
    method: 'post',
    data: params
  })
}
// 后台审核
export const backCheck = (params) => {
  return service({
    url: API_LIST.backEnd.check,
    method: 'get',
    params: params
  })
}
// 用户投票
// ocCode
// opClientType：固定值（CLIENT_WX）
// operateCode
export const userVote = (params) => {
  return service({
    url: API_LIST.user.vote,
    method: 'post',
    data: params
  })
}
/*
  operateCode
  ocCode
  opClientType：（CLIENT_WX :普通用户投票，CLIENT_ZJF :专家用户第一轮投票， CLIENT_ZJS :专家用户第二轮投票）
 */
export const specialUserVote = (params) => {
  return service({
    url: API_LIST.act.sVote,
    method: 'post',
    data: params
  })
}
export default Object.assign({
  // getMapData,
  getShareParams,
  getSysTime,
  getAllData,
  getList,
  getDetail,
  getSpecialList,
  getSpecialDetail,
  uploadWorks,
  getBackList,
  getBackDetail,
  backUpdate,
  backCheck,
  userVote,
  specialUserVote,
  getSong,
  getTotalNum,
  backDelete,
  getSongList,
  getSongdetail,
  VistorRead,
  insertVistor
})



// WEBPACK FOOTER //
// ./src/api/interface/common.js